import { useContent } from "../context/ContentContext";
import { contentFallback } from "../contentDefaults";

export function useContentData(key, fallback = null) {
  const fb = fallback ?? contentFallback(key);
  const { value, loading } = useContent(key, fb);
  return { value: value ?? fb, loading };
}

export function useContentList(key, fallback = []) {
  const { value, loading } = useContentData(key, fallback);
  const list = Array.isArray(value) ? value : (Array.isArray(fallback) ? fallback : []);
  return { items: list, loading };
}

export function useContentObject(key, fallback = {}) {
  const { value, loading } = useContentData(key, fallback);
  const fb = fallback && typeof fallback === "object" && !Array.isArray(fallback) ? fallback : {};
  const obj = value && typeof value === "object" && !Array.isArray(value) ? value : fb;
  return { data: { ...fb, ...obj }, loading };
}
